if (!customElements.get('marame-cart-scent')) {
  customElements.define('marame-cart-scent', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      const fallback = this.querySelector('[data-cart-scent-fallback]');
      fallback.hidden = true;
      fallback.querySelectorAll('input').forEach((input) => { input.disabled = true; });
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('submit', (event) => {
        if (event.target.id !== 'cart' || event.submitter?.name !== 'checkout' || this.confirmed) return;
        event.preventDefault();
        this.checkoutButton = event.submitter;
        if (!this.dialog.open) this.dialog.showModal();
        this.dialog.querySelector('h2').focus();
      }, options);
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-scent-close]')) this.dialog.close();
        const button = event.target.closest('[data-cart-scent-choice]');
        if (button) this.save(button.dataset.cartScentChoice);
      }, options);
      this.dialog.addEventListener('close', () => {
        this.run = (this.run || 0) + 1;
        this.confirmed = false;
        if (this.checkoutButton?.isConnected) this.checkoutButton.focus();
      }, options);
    }

    disconnectedCallback() {
      this.run = (this.run || 0) + 1;
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
    }

    async save(choice) {
      if (this.saving || !this.dialog.open || !['yes', 'no'].includes(choice)) return;
      const run = this.run = (this.run || 0) + 1;
      this.saving = true;
      const error = this.querySelector('[data-cart-scent-error]');
      const saving = this.querySelector('[data-cart-scent-saving]');
      const buttons = [...this.querySelectorAll('[data-cart-scent-choice]')];
      error.hidden = true;
      saving.hidden = false;
      buttons.forEach((button) => { button.disabled = true; });
      this.dialog.setAttribute('aria-busy', 'true');
      try {
        const input = document.getElementById('Cart-note');
        const cart = await window.marameQueueCartNote((note) => window.maramePackagingNote(note, choice));
        if (input) input.value = cart.note || '';
        const drawerNote = document.getElementById('CartDrawer-Note');
        if (drawerNote) drawerNote.value = cart.note || '';
        if (run !== this.run || !this.isConnected || !this.dialog.open) return;
        const form = document.getElementById('cart');
        const button = document.getElementById('checkout');
        if (!form || !button || button.disabled) throw new Error('Checkout unavailable');
        this.confirmed = true;
        try { form.requestSubmit(button); } finally { this.confirmed = false; }
      } catch {
        if (run === this.run && this.isConnected) error.hidden = false;
      } finally {
        this.saving = false;
        saving.hidden = true;
        buttons.forEach((button) => { button.disabled = false; });
        this.dialog.removeAttribute('aria-busy');
      }
    }
  });
}

document.addEventListener('change', (event) => {
  if (event.target.id !== 'Cart-note' || !event.target.closest('[data-marame-page-note]')) return;
  const error = document.querySelector('[data-marame-page-note-error]');
  const note = event.target.value;
  window.marameQueueCartNote(note).then(() => {
    if (error) error.hidden = true;
  }, () => {
    if (error) error.hidden = false;
  });
});

const maramePageNote = document.getElementById('Cart-note');
if (maramePageNote) maramePageNote.disabled = false;
